import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

//
//
//
//
//
//
//
//
//
//
//
//
//
var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

export default {
  name: 'ArticleParagraph',
  components: {
    GlobalRichText: GlobalRichText
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    currentPayload: function currentPayload() {
      var _ref, _ref2;

      return {
        title: ((_ref2 = this.payload) != null ? (_ref2 = _ref2.primary) != null ? (_ref2 = _ref2.title) != null ? (_ref2 = _ref2[0]) != null ? _ref2.text : _ref2 : _ref2 : _ref2 : _ref2) || '',
        text: ((_ref = this.payload) != null ? (_ref = _ref.primary) != null ? _ref.text : _ref : _ref) || []
      };
    }
  }
};